import { storeDeps } from "./deps";
import { createAuthStore, createMemoStore } from "@repo/exit-calc-stores";

export const useAuthStore = createAuthStore(storeDeps);
export const useMemoStore = createMemoStore(storeDeps);

export type { AuthStore, MemoStore } from "@repo/exit-calc-stores";
